import request from "root/js/request";

export const postCalcOptionsWarehouses = async ({
  cabinet_id,
  with_market_context,
  forecast_period,
  count_as_new_product_period_days,
  base_filters,

  abc_groups_exclude,
  stock_days_exclude,
  stock_days_comp_exclude,
  new_products_exclude,
  brand_ids_exclude,
  subject_ids_exclude,
  product_ids_exclude,

  coef,
  abc_groups_unexpected_demand,
  stock_days_unexpected_demand,
  stock_days_comp_unexpected_demand,
  new_products_unexpected_demand,
  brand_ids_unexpected_demand,
  subject_ids_unexpected_demand,
  product_ids_unexpected_demand,

  days,
  abc_groups_minimum_balance,
  stock_days_minimum_balance,
  stock_days_comp_minimum_balance,
  new_products_minimum_balance,
  brand_ids_minimum_balance,
  subject_ids_minimum_balance,
  product_ids_minimum_balance,

  min_distribution_quantity,
  min_region_cluster_sales_share,
  nearest_possible_supply_date,
  supply_frequency,
  supply_preparation_days,
  rc_prep_times,
  wh_prep_times,
  with_moysklad_stocks,
  transit_warehouse,
}) => {
  const response = await request({
    url: `analytics/wh_supply/calc_options/`,
    method: "post",
    params: {
      cabinet_id,
    },
    data: {
      cabinet_id,
      options: {
        transit_warehouse,
        with_market_context,
        forecast_period,
        count_as_new_product_period_days,
        base_filters: base_filters,
        exclude: {
          abc_groups: abc_groups_exclude,
          stock_days: stock_days_exclude,
          stock_days_comp: stock_days_comp_exclude,
          new_products: new_products_exclude,
          brand_ids: brand_ids_exclude,
          subject_ids: subject_ids_exclude,
          product_ids: product_ids_exclude,
        },
        unexpected_demand_reserve: {
          coef,
          abc_groups: abc_groups_unexpected_demand,
          stock_days: stock_days_unexpected_demand,
          stock_days_comp: stock_days_comp_unexpected_demand,
          new_products: new_products_unexpected_demand,
          brand_ids: brand_ids_unexpected_demand,
          subject_ids: subject_ids_unexpected_demand,
          product_ids: product_ids_unexpected_demand,
        },
        minimum_balance: {
          days,
          abc_groups: abc_groups_minimum_balance,
          stock_days: stock_days_minimum_balance,
          stock_days_comp: stock_days_comp_minimum_balance,
          new_products: new_products_minimum_balance,
          brand_ids: brand_ids_minimum_balance,
          subject_ids: subject_ids_minimum_balance,
          product_ids: product_ids_minimum_balance,
        },
        min_distribution_quantity,
        min_region_cluster_sales_share,
        nearest_possible_supply_date,
        supply_frequency,
        supply_preparation_days,
        rc_prep_times,
        wh_prep_times,
        with_moysklad_stocks,

        //private options
        period: 360,
        with_trend: true,
        with_seasonality: true,
        with_seasonality_spikes: true,
        with_mp_growth: true,
        with_company_plan: true,
        with_return_share: true,
        with_cancle_share: true,
        with_abc_xyz_cz_excluded: true,
        with_safety_stock: true,
        with_in_way_stocks: true,
        with_saved_additional_delivery: true,
        abc_labels: "0.8:A,0.15:B,0.05:C",
        xyz_labels: "0.1:X,0.25:Y,inf:Z",
        trend_calc_method: "sktime",
      },
    },
  });
  return response.data;
};

export const getCalcOptionsWarehouses = async ({ cabinet_id }) => {
  const response = await request({
    url: `analytics/wh_supply/calc_options/`,
    method: "get",
    params: {
      cabinet_id,
    },
  });
  return response.data;
};
